/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// NewUser page components
import FormField from "components/FormField";
import MDTypography from "components/MDTypography";
import MDImage from "components/MDImage/image";
import { useSelector } from "react-redux";
import { Icon, Tooltip } from "@mui/material";
import { admin_state } from "slices";
import { useSnackbar } from "notistack";
import no_foto from "assets/images/404.jpg";
import { useGetEntidadesFederativasQuery } from "services/administracion/entidad_federativa.service";

const style = {
  width: "100%",
  cursor: "pointer",
  borderRadius: "0.5rem",
  maxWidth: "600px",
  minWidth: "100px",
  boxShadow: " 2px 2px 4px rgba(0, 0, 0, 0.2)",
};
const icon_style = {
  position: "absolute",
  left: "50%",
  top: "50%",
  fontSize: "30px",
  transform: "translate(-50%,-50%)",
};

function AddEntidad({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    nombre,
    logo,
    municipio,
    localidad,
    clave_del_centro,
    dominio,
    federativa,
    dominio_de_correo,
  } = formField;
  const {
    nombre: nombreE,
    logo: logoE,
    municipio: municipioE,
    dominio_de_correo: dominio_de_correoE,
    localidad: localidadE,
    clave_del_centro: clave_del_centroE,
    federativa: federativaE,
  } = values;

  const { data: entidadesFederativas } = useGetEntidadesFederativasQuery(
    {
      shape: {
        id_entidad: "id_entidad",
        entidad: "entidad",
        abr: "abr",
        nid: "nid",
      },
    },
    { refetchOnReconnect: true },
  );

  const { edit } = useSelector(admin_state);
  const { enqueueSnackbar } = useSnackbar();

  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormField
            type={nombre.type}
            label={nombre.label}
            name={nombre.name}
            value={nombreE}
            placeholder={nombre.placeholder}
            error={errors.nombre && touched.nombre}
            success={nombreE?.length > 0 && !errors.nombre}
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormField
            type={clave_del_centro.type}
            label={clave_del_centro.label}
            name={clave_del_centro.name}
            value={clave_del_centroE}
            placeholder={clave_del_centro.placeholder}
            error={errors.clave_del_centro && touched.clave_del_centro}
            success={clave_del_centroE?.length > 0 && !errors.clave_del_centro}
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormField
            select
            type={federativa.type}
            label={federativa.label}
            name={federativa.name}
            value={federativaE === null ? "" : federativaE}
            placeholder={federativa.placeholder}
            error={errors.federativa && touched.federativa}
            success={Boolean(federativaE) && !errors.federativa}
          >
            <MenuItem key="0" value={""}>
              No seleccionado
            </MenuItem>
            {entidadesFederativas
              ?.slice()
              .sort((a, b) => a.entidad.localeCompare(b.entidad))
              .map((el) => (
                <MenuItem key={el.id_entidad} value={el.entidad}>
                  {el.entidad}
                </MenuItem>
              ))}
          </FormField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormField
            type={municipio.type}
            label={municipio.label}
            name={municipio.name}
            value={municipioE}
            placeholder={municipio.placeholder}
            error={errors.municipio && touched.municipio}
            success={municipioE?.length > 0 && !errors.municipio}
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormField
            type={localidad.type}
            label={localidad.label}
            name={localidad.name}
            value={localidadE}
            placeholder={localidad.placeholder}
            error={errors.localidad && touched.localidad}
            success={localidadE?.length > 0 && !errors.localidad}
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormField
            type={dominio_de_correo.type}
            label={dominio_de_correo.label}
            name={dominio_de_correo.name}
            value={dominio_de_correoE}
            placeholder={dominio_de_correo.placeholder}
            error={errors.dominio_de_correo && touched.dominio_de_correo}
            success={
              dominio_de_correoE?.length > 0 && !errors.dominio_de_correo
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} display="flex" justifyContent={"center"}>
        <Grid item xs={12} sm={6}>
          <MDBox
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
          >
            <MDTypography variant="h6" fontWeight="bold">
              Logo:
            </MDTypography>
            <MDBox mt={1.625} display="flex" justifyContent="center">
              <Tooltip
                placement="top"
                title={!logoE ? "Agregar imagen" : "Cambiar Foto"}
              >
                <MDBox
                  style={{
                    position: "relative",
                    width: "200px",
                    cursor: "pointer",
                  }}
                >
                  {!logoE ? (
                    <Icon fontSize="medium" style={icon_style}>
                      image_search
                    </Icon>
                  ) : null}

                  <MDImage
                    id="logo-image"
                    htmlFor="logo-image"
                    style={style}
                    src={
                      logoE
                        ? typeof logoE === "string"
                          ? logoE
                          : URL.createObjectURL(logoE)
                        : no_foto
                    }
                    handleChange={(e) => {
                      const file = e.target.files[0];
                      const maxSize = 1024 * 1024; // 250 KB

                      if (file.size > maxSize) {
                        enqueueSnackbar(
                          "El tamaño de la imagen no debe ser mayor a 1 MB",
                          {
                            variant: "error",
                            autoHideDuration: 4000,
                          },
                        );
                        return;
                      } else {
                        setFieldValue(logo.name, e.target.files[0]);
                      }
                    }}
                  />
                </MDBox>
              </Tooltip>
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

// typechecking props for EntidadInfo
AddEntidad.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default AddEntidad;
